import * as tslib_1 from "tslib";
import * as esriLoader from 'esri-loader';
import { environment } from '../environment';
var MapViewExtender = /** @class */ (function () {
    function MapViewExtender() {
    }
    MapViewExtender.construct = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, mapView, MCMapView;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, esriLoader.loadModules(['esri/views/MapView'], window.esriConfig)];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 1]), mapView = _a[0];
                        MCMapView = function (esriProps, mapId, mapApi, layerService) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var tempMapView, result;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        tempMapView = new mapView(esriProps);
                                        tempMapView.resetMapProps = function (map) {
                                            if (map === void 0) { map = null; }
                                            this.map.removeAll();
                                            if (!map) {
                                                map = {
                                                    description: '',
                                                    id: null,
                                                    isPublic: null,
                                                    isSystem: null,
                                                    name: 'New Map'
                                                };
                                            }
                                            this.mapcoreViewProps = tslib_1.__assign({}, map);
                                            this.mapcoreViewProps.applicationID = environment.appId;
                                        };
                                        tempMapView.addMapcoreLayerToMap = function (layerId, query) {
                                            var layerSettings = { id: layerId, query: query ? query : null };
                                            layerService.addMapcoreLayersToMap([layerSettings]);
                                        };
                                        if (!mapId) return [3 /*break*/, 2];
                                        return [4 /*yield*/, mapApi.getMaps(mapId)];
                                    case 1:
                                        result = _a.sent();
                                        tempMapView.mapcoreViewProps = result[0];
                                        tempMapView.mapcoreViewProps.applicationID = environment.appId;
                                        tempMapView.container = esriProps.container;
                                        tempMapView.map = esriProps.map;
                                        tempMapView.ui = esriProps.ui;
                                        tempMapView.center = null; //map center from map
                                        tempMapView.zoom = null; //zoom from map
                                        return [3 /*break*/, 3];
                                    case 2:
                                        tempMapView.container = esriProps.container;
                                        tempMapView.map = esriProps.map;
                                        tempMapView.ui = esriProps.ui;
                                        tempMapView.center = esriProps.center;
                                        tempMapView.zoom = esriProps.zoom;
                                        tempMapView.resetMapProps();
                                        _a.label = 3;
                                    case 3: return [2 /*return*/, tempMapView];
                                }
                            });
                        }); };
                        return [2 /*return*/, MCMapView];
                }
            });
        });
    };
    return MapViewExtender;
}());
export { MapViewExtender };
